import { render, staticRenderFns } from "./ModalLeadsArchive.vue?vue&type=template&id=de5d94b2&"
import script from "./ModalLeadsArchive.vue?vue&type=script&lang=js&"
export * from "./ModalLeadsArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports